import { useEffect, useState } from 'react';
import { getHiddenRoutes, hideRoute } from '../lib/data';

// Список скрытых маршрутов СВ с возвратом (только для тех, у кого включено can_hide_routes)
export default function HiddenRoutes({ svId, actorId, refreshKey, onRestored }) {
  const [list, setList] = useState([]);
  const [err, setErr] = useState('');
  useEffect(() => {
    let off = false;
    getHiddenRoutes(svId).then(r => { if (!off) setList(r); }).catch(e => { if (!off) setErr(e.message); });
    return () => { off = true; };
  }, [svId, refreshKey]);
  if (!list.length && !err) return null;
  return (
    <div style={{ margin: '12px 0', padding: '10px 14px', border: '1px dashed #CBD5E0', borderRadius: 8, background: '#F7F9FC' }}>
      <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6 }}>Скрытые маршруты ({list.length})</div>
      {err && <div style={{ fontSize: 12, color: 'var(--red)' }}>{err}</div>}
      {list.map(r => {
        const m = Array.isArray(r.merchandisers) ? r.merchandisers[0] : r.merchandisers;
        return (
          <div key={r.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 12, padding: '3px 0' }}>
            <span>{r.internal_code} · {m?.full_name || 'Вакансия'}</span>
            <button onClick={async () => {
              try { await hideRoute(r.id, false, actorId); setList(l => l.filter(x => x.id !== r.id)); onRestored && onRestored(r); }
              catch (e) { setErr(e.message); }
            }} style={{ fontSize: 11, color: 'var(--accent)', background: 'none', border: '1px solid var(--accent)', borderRadius: 6, padding: '1px 8px', cursor: 'pointer' }}>Вернуть</button>
          </div>
        );
      })}
    </div>
  );
}
